import { Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { IBreadcrumb } from "src/ui/Breadcrumbs/Breadcrumbs"
import { BreadcrumbView } from "src/ui/Layout/BreadcrumbView"

import { PortfolioAnalyticsIntegrationsStatus } from "./IntegrationStatus/PortfolioAnalyticsIntegrationsStatus"

export function PortfolioAnalytics() {
  const { t, langKeys, tPlaceholder } = useTranslate()

  const breadcrumbs: IBreadcrumb[] = [
    { label: t(langKeys.report_plural), to: Routes.Reports.location() },
    {
      label: tPlaceholder("Portfolio Analytics"),
      to: Routes.PortfolioAnalytics.location(),
    },
  ]

  return (
    <BreadcrumbView
      breadcrumbs={breadcrumbs}
      title={
        <Text variant="heading1">{tPlaceholder("Portfolio Analytics")}</Text>
      }
    >
      <Text variant="body">
        {tPlaceholder(
          "This is a placeholder for the Portfolio Analytics view."
        )}
      </Text>
      <PortfolioAnalyticsIntegrationsStatus />
    </BreadcrumbView>
  )
}
